module.exports = __webpack_public_path__ + "media/img/android-icon-192x192-9ed54d6b846713c2e52c47e945f1203d.png";